// JavaScript source code
function getCookieValue(name) {
  // Construct the name of the cookie followed by an equal sign
  let nameEQ = name + "=";

  // Split the cookies stored in document.cookie by semicolons
  let cookies = document.cookie.split(";");

  // Loop through the cookies array
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];

    // Trim any leading whitespace
    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1, cookie.length);
    }

    // If the cookie starts with the desired nameEQ, extract and return its value
    if (cookie.indexOf(nameEQ) == 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }

  // If the cookie is not found, return null
  return null;
}

function setCookie(name, value, days = null) {
  if (days == null) {
    // Set the cookie with the name, value, and expiration date
    document.cookie = name + "=" + value + ";path=/";
  } else {
    let date = new Date();
    // Set the time to the current time plus the specified number of days
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

    // Construct the cookie string with the expiration date in GMT format
    let expires = "expires=" + date.toUTCString() + ";";

    // Set the cookie with the name, value, and expiration date
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }
}
